module.exports = __webpack_public_path__ + "static/media/WeddingTheme.ad52a46e.png";